import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { newUbicacionesSchema } from '@/shared';
import { useCreateUbicaciones, useUpdateUbicaciones, useFetchBodegas } from '@/shared/actions/erp';
import {
  SingleFormBoxScene,
  CustomAutocomplete,
  SampleCheckbox,
  CustomTextField
} from '@/shared/components/ui';
import { useUiStore } from '@/store/ui';
import { BODEGAS, Ubicaciones } from '@/shared/interfaces/erp/inventario';


const returnUrlUbi = '/inventario/ubicaciones';

export interface SaveUbicacionesInterface {
  titlePage: string;
  editUbicaciones?: Ubicaciones;
}

type SaveFormData = {
  nombre: string;
  bodega: string;
  numero_referencia?: string;
  estado: boolean;
};

const SaveUbicaciones: React.FC<SaveUbicacionesInterface> = ({ titlePage, editUbicaciones }) => {
  
  //******alert */
  const setAlert = useUiStore(s => s.setAlert);

  const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);
  const [selectedBodega, setSelectedBodega] = useState('');

  ///* mutations
  const createUbicacionesMutation = useCreateUbicaciones({ navigate, returnUrl: returnUrlUbi });
  const updateUbicacionesMutation = useUpdateUbicaciones({ navigate, returnUrl: returnUrlUbi });

  ///* fetch data
  const { data: BodegasPaging, isLoading: isLoadingBodegas } = useFetchBodegas({
    page_size: 600,
  });

  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newUbicacionesSchema),
    defaultValues: {
      estado: false,
    }
  });
  const {
    handleSubmit,
    reset,
    control,
    formState: { errors, isValid },
  } = form;

  ///* handlers
  const onSave = () => {
    if (!isValid) {
      setAlert(true, 'Faltan campos requeridos', 'error');
      console.log(form.getValues());
      return;
    }

    ///* upd
    if (editUbicaciones?.id_ubicacion) {
      return updateUbicacionesMutation.mutate({
        id: editUbicaciones.id_ubicacion,
        data: form.getValues() as any, // percent
      });
    }

    ///* create
    return createUbicacionesMutation.mutate(form.getValues() as any);
  };
  ///*fetch
  const onChangeUbicaciones = (value: string) => {
    setSelectedBodega(value);
    form.setValue('bodega', value);
  };

  ///* effects
  useEffect(() => {
    if (editUbicaciones) {
      setShrink(true);
      reset({
        ...editUbicaciones,
      } as any);
    }
  }, [editUbicaciones]);

  //Ubicaciones aviable
  useEffect(() => {
    if (
      selectedBodega &&
      BodegasPaging &&
      !(BodegasPaging?.data.data.length > 0)
    ) {
      setAlert(
        true,
        'No se encontraron bodegas disponibles. No se podrá crear el proveedor.',
        'error'
      );
    }
  }, [BodegasPaging, selectedBodega]);

  return (
    <SingleFormBoxScene
      titlePage={titlePage}
      onCancel={() => {
        navigate(returnUrlUbi);
      }}
      onSave={handleSubmit(onSave)}
    >
      <CustomTextField
        name="nombre"
        label="Nombre"
        control={form.control}
        defaultValue={form.getValues().nombre || ""}
        error={errors.nombre}
        helperText={errors.nombre?.message}
        shrink={shrink}
      />
      <CustomTextField
        name="numero_referencia"
        label="Número de referencia"
        control={form.control}
        defaultValue={form.getValues().numero_referencia || ""}
        error={errors.numero_referencia}
        helperText={errors.numero_referencia?.message}
        shrink={shrink}
      />

      <CustomAutocomplete<BODEGAS>
        label="Bodegas"
        name="bodega"
        // options
        options={BodegasPaging?.data.data || []}
        valueKey="nombre" // name is the fk
        actualValueKey="codigo"
        defaultValue={form.getValues().bodega || ''}
        isLoadingData={isLoadingBodegas}
        control={control}
        error={errors.bodega}
        helperText={errors.bodega?.message}
        onChangeValue={onChangeUbicaciones}
        optionLabelForEdit={
          BodegasPaging?.data.data.find(
            z => z.codigo === form.getValues().bodega
          )?.codigo || ''
        }
      />
      <SampleCheckbox
        label="Estado"
        name="estado"
        control={form.control}
        defaultValue={!!form.getValues().estado}
        isState
      />
    </SingleFormBoxScene>
  );
};

export default SaveUbicaciones;
